import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Spinner from 'react-spinkit';
import { useTranslation } from 'react-i18next';
import Wrapper from '../comnon/wrapper';
import useTitle from '../comnon/title';

const AFRManagement = () => {
    const { t } = useTranslation();
    const { settingsData } = useSelector(state => state.user);
    const [loading, setLoading] = useState(true);
    const [dots, setDots] = useState('.');
    useTitle(t('sidebar.afr-management'));

    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prevDots => prevDots === '...' ? '.' : prevDots + '.');
        }, 1000);

        return () => clearInterval(interval);

    }, []);

    const hideSpinner = () => {
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }

    return (
        <Wrapper>
            <div className='padding-around report-mngmnt-view'
                 style={{
                     height: '100%',
                     position: 'relative',
                 }}
            >
                {
                    loading ?
                        <>
                            <Spinner name='ball-clip-rotate' color='#006ac3'
                                     style={{
                                         position: 'absolute',
                                         top: '50%',
                                         left: '50%',
                                         transform: 'translate(-50%, -50%)',
                                         zIndex: 9999
                                     }}
                            />

                            <p
                                style={{
                                    position: 'absolute',
                                    top: '55%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    color: '#006ac3',
                                    fontWeight: 'bold',
                                    fontSize: '18px'
                                }}
                            >
                                Loading{dots}
                            </p>

                        </>

                        :
                        null
                }

                <iframe width="100%" height="1600px"
                        allow="clipboard-write;camera;geolocation;fullscreen"
                        onLoad={hideSpinner}
                        frameBorder="0"
                        src={`${settingsData?.afr_management_embed_code_url}`}>
                </iframe>

            </div>
        </Wrapper>

    )
};

export default AFRManagement;